var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2733_7915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2733_7915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 39,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9961 14H13.9961V52H51.9961V14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2733_7915)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8961 14C35.9455 14 36.7961 14.8507 36.7961 15.9V19.239C36.7961 20.9317 38.8426 21.7794 40.0396 20.5825L42.4005 18.2215C43.1427 17.4795 44.3456 17.4795 45.0877 18.2215L47.7747 20.9085C48.5166 21.6505 48.5166 22.8535 47.7747 23.5955L45.4135 25.9565C44.2167 27.1534 45.0643 29.2 46.757 29.2H50.0961C51.1455 29.2 51.9961 30.0506 51.9961 31.1V34.9C51.9961 35.9494 51.1455 36.8 50.0961 36.8H46.757C45.0643 36.8 44.2167 38.8465 45.4135 40.0435L47.7747 42.4044C48.5166 43.1466 48.5166 44.3495 47.7747 45.0916L45.0877 47.7786C44.3456 48.5205 43.1427 48.5205 42.4005 47.7786L40.0396 45.4174C38.8426 44.2206 36.7961 45.0682 36.7961 46.7609V50.1C36.7961 51.1494 35.9455 52 34.8961 52H31.0961C30.0467 52 29.1961 51.1494 29.1961 50.1V46.7609C29.1961 45.0682 27.1495 44.2206 25.9526 45.4174L23.5916 47.7786C22.8496 48.5205 21.6466 48.5205 20.9046 47.7786L18.2176 45.0916C17.4756 44.3495 17.4756 43.1466 18.2176 42.4044L20.5786 40.0435C21.7755 38.8465 20.9278 36.8 19.2351 36.8H15.8961C14.8468 36.8 13.9961 35.9494 13.9961 34.9V31.1C13.9961 30.0506 14.8468 29.2 15.8961 29.2H19.2351C20.9278 29.2 21.7755 27.1534 20.5786 25.9565L18.2176 23.5955C17.4756 22.8535 17.4756 21.6505 18.2176 20.9085L20.9046 18.2215C21.6466 17.4795 22.8496 17.4795 23.5916 18.2215L25.9526 20.5825C27.1495 21.7794 29.1961 20.9317 29.1961 19.239V15.9C29.1961 14.8507 30.0467 14 31.0961 14H34.8961ZM32.9961 42.5C38.2428 42.5 42.4961 38.2467 42.4961 33C42.4961 27.7533 38.2428 23.5 32.9961 23.5C27.7494 23.5 23.4961 27.7533 23.4961 33C23.4961 38.2467 27.7494 42.5 32.9961 42.5Z",
    fill: "#14705F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2733_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.cc69b2f7a6996873112663f7ad67dbc7.svg";
export { ForwardRef as ReactComponent };